import { IBreadcrumb } from './Breadcrumb';
import { Route, IBreadcrumbItem, BreadcrumbItem } from './BreadcrumbItem';

//
export interface IBreadcrumbs {
  items: IBreadcrumb[];
  add(item: IBreadcrumb): IBreadcrumbs;
  addItems(items: IBreadcrumb[]): IBreadcrumbs;
  getItems(): IBreadcrumb[];
  createItem(title: string, route: Route): IBreadcrumbItem;
  getByName(name: string): IBreadcrumb | null;
}
export class Breadcrumbs implements IBreadcrumbs {
  public items: IBreadcrumb[] = [];
  getItems() {
    return this.items;
  }
  addItems(items: IBreadcrumb[]) {
    items.forEach(i => this.items.push(i));
    return this;
  }
  getByName(name: string) {
    const item = this.items.find(i => i.key === name);
    return item ? item : null;
  }
  add(item: IBreadcrumb) {
    this.items.push(item);
    return this;
  }
  createItem(title: string, route: Route) {
    return new BreadcrumbItem(title, route);
  }
}

export const breadcrumbs = new Breadcrumbs();
